import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-[#0f1419] py-12 px-4 border-t border-[#2d3e50]" data-id="element-24">
        <div className="max-w-6xl mx-auto" data-id="element-25">
          <div className="flex flex-col items-center gap-6" data-id="element-26">
            {/* Links */}
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm" data-id="element-27">
              <button onClick={() => setShowPrivacy(true)} className="text-[#d1d9e6] hover:text-[#e8edf4] transition-colors underline focus:outline-none focus:ring-2 focus:ring-[#a8b5d1]/30 rounded px-2 py-1" data-id="element-28">
                Política de Privacidad
              </button>
              <span className="text-[#2d3e50]" data-id="element-29">•</span>
              <button onClick={() => setShowTerms(true)} className="text-[#d1d9e6] hover:text-[#e8edf4] transition-colors underline focus:outline-none focus:ring-2 focus:ring-[#a8b5d1]/30 rounded px-2 py-1" data-id="element-30">
                Términos de Servicio
              </button>
            </div>

            {/* Copyright */}
            <p className="text-[#b8c5d6] text-sm text-center" data-id="element-31">
              © 2024 Apaga la Cabeza en 10 Min. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-32">
        <div className="space-y-6" data-id="element-33">
          <p className="text-sm text-gray-500" data-id="element-34">
            Última actualización: Diciembre 2024
          </p>

          <section data-id="element-35">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-36">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-37">
              Cuando adquieres nuestro protocolo "Apaga la Cabeza en 10 Min",
              recopilamos la siguiente información:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2" data-id="element-38">
              <li data-id="element-39">Dirección de correo electrónico para entrega del producto</li>
              <li data-id="element-40">
                Información de pago procesada de forma segura a través de
                nuestro procesador de pagos
              </li>
              <li data-id="element-41">
                Datos de navegación básicos (dirección IP, tipo de navegador)
                para mejorar nuestro servicio
              </li>
            </ul>
          </section>

          <section data-id="element-42">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-43">
              2. Cómo Usamos tu Información
            </h3>
            <p data-id="element-44">Utilizamos tu información para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2" data-id="element-45">
              <li data-id="element-46">Entregarte el producto digital (PDF) que has adquirido</li>
              <li data-id="element-47">Enviarte actualizaciones importantes sobre tu compra</li>
              <li data-id="element-48">Proporcionar soporte al cliente cuando lo necesites</li>
              <li data-id="element-49">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-50">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-51">
              3. Protección de Datos
            </h3>
            <p data-id="element-52">
              Tomamos la seguridad de tus datos muy en serio. Implementamos
              medidas de seguridad técnicas y organizativas para proteger tu
              información personal contra acceso no autorizado, pérdida o
              alteración. Todos los pagos son procesados a través de plataformas
              seguras y certificadas.
            </p>
          </section>

          <section data-id="element-53">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-54">
              4. Compartir Información
            </h3>
            <p data-id="element-55">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros, excepto:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2" data-id="element-56">
              <li data-id="element-57">
                Con procesadores de pago necesarios para completar tu
                transacción
              </li>
              <li data-id="element-58">Cuando sea requerido por ley o autoridades competentes</li>
            </ul>
          </section>

          <section data-id="element-59">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-60">
              5. Tus Derechos
            </h3>
            <p data-id="element-61">Tienes derecho a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2" data-id="element-62">
              <li data-id="element-63">Acceder a la información personal que tenemos sobre ti</li>
              <li data-id="element-64">Solicitar la corrección de datos inexactos</li>
              <li data-id="element-65">Solicitar la eliminación de tus datos personales</li>
              <li data-id="element-66">Oponerte al procesamiento de tus datos</li>
            </ul>
          </section>

          <section data-id="element-67">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-68">
              6. Cookies
            </h3>
            <p data-id="element-69">
              Utilizamos cookies esenciales para el funcionamiento básico del
              sitio web. No utilizamos cookies de seguimiento o publicidad de
              terceros.
            </p>
          </section>

          <section data-id="element-70">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-71">
              7. Contacto
            </h3>
            <p data-id="element-72">
              Si tienes preguntas sobre esta Política de Privacidad o deseas
              ejercer tus derechos, puedes contactarnos respondiendo al correo
              electrónico desde el cual recibiste tu producto.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos de Servicio" data-id="element-73">
        <div className="space-y-6" data-id="element-74">
          <p className="text-sm text-gray-500" data-id="element-75">
            Última actualización: Diciembre 2024
          </p>

          <section data-id="element-76">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-77">
              1. Aceptación de Términos
            </h3>
            <p data-id="element-78">
              Al adquirir "Apaga la Cabeza en 10 Min", aceptas estos Términos de
              Servicio. Si no estás de acuerdo con alguno de estos términos, por
              favor no realices la compra.
            </p>
          </section>

          <section data-id="element-79">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-80">
              2. Descripción del Producto
            </h3>
            <p data-id="element-81">
              "Apaga la Cabeza en 10 Min" es un producto digital (PDF) que
              contiene un protocolo de 7 noches diseñado para ayudar a manejar
              la ansiedad nocturna y mejorar la calidad del sueño. El producto
              incluye:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2" data-id="element-82">
              <li data-id="element-83">Protocolo 3C completo (Cuerpo, Cerebro, Cama)</li>
              <li data-id="element-84">Plan de Emergencia 3AM</li>
              <li data-id="element-85">Plantillas imprimibles</li>
              <li data-id="element-86">Guía de 7 noches</li>
            </ul>
          </section>

          <section data-id="element-87">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-88">
              3. Entrega del Producto
            </h3>
            <p data-id="element-89">
              El producto digital será entregado inmediatamente después de
              completar tu compra a través de un enlace de descarga enviado a tu
              correo electrónico. Es tu responsabilidad proporcionar una
              dirección de correo válida y verificar tu carpeta de spam si no
              recibes el producto.
            </p>
          </section>

          <section data-id="element-90">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-91">
              4. Política de Reembolsos
            </h3>
            <p data-id="element-92">
              Debido a la naturaleza digital del producto y la entrega
              inmediata, no ofrecemos reembolsos una vez que el producto ha sido
              descargado. Te recomendamos leer toda la información del producto
              antes de realizar tu compra.
            </p>
          </section>

          <section data-id="element-93">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-94">
              5. Licencia de Uso
            </h3>
            <p data-id="element-95">
              Al adquirir este producto, recibes una licencia de uso personal y
              no transferible. Esto significa que:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2" data-id="element-96">
              <li data-id="element-97">Puedes usar el protocolo para tu beneficio personal</li>
              <li data-id="element-98">
                NO puedes compartir, revender, redistribuir o reproducir el
                contenido
              </li>
              <li data-id="element-99">
                NO puedes usar el contenido con fines comerciales sin
                autorización
              </li>
            </ul>
          </section>

          <section data-id="element-100">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-101">
              6. Descargo de Responsabilidad Médica
            </h3>
            <p className="font-semibold text-[#e76f51]" data-id="element-102">IMPORTANTE:</p>
            <p data-id="element-103">
              Este protocolo NO es un tratamiento médico, terapia psicológica ni
              sustituye la atención profesional de salud. Es un recurso de
              autocuidado basado en técnicas de regulación nerviosa para uso
              informativo y educativo.
            </p>
            <p className="mt-2" data-id="element-104">
              Si experimentas ansiedad severa, insomnio crónico, o cualquier
              condición de salud mental que requiera atención profesional, por
              favor consulta con un médico o profesional de salud mental
              calificado.
            </p>
          </section>

          <section data-id="element-105">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-106">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-107">
              El uso de este protocolo es bajo tu propia responsabilidad. No
              garantizamos resultados específicos, ya que cada persona es
              diferente. No nos hacemos responsables por cualquier daño directo,
              indirecto, incidental o consecuente que pueda surgir del uso o
              imposibilidad de uso de este producto.
            </p>
          </section>

          <section data-id="element-108">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-109">
              8. Propiedad Intelectual
            </h3>
            <p data-id="element-110">
              Todo el contenido de "Apaga la Cabeza en 10 Min", incluyendo
              textos, gráficos, diseños y metodología, está protegido por
              derechos de autor. Cualquier uso no autorizado constituye una
              violación de estos derechos.
            </p>
          </section>

          <section data-id="element-111">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-112">
              9. Modificaciones
            </h3>
            <p data-id="element-113">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación. Es tu responsabilidad revisar periódicamente estos
              términos.
            </p>
          </section>

          <section data-id="element-114">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-115">
              10. Ley Aplicable
            </h3>
            <p data-id="element-116">
              Estos términos se rigen por las leyes de Colombia. Cualquier
              disputa será resuelta en los tribunales competentes de Colombia.
            </p>
          </section>

          <section data-id="element-117">
            <h3 className="text-xl font-semibold text-[#1a2332] mb-3" data-id="element-118">
              11. Contacto
            </h3>
            <p data-id="element-119">
              Si tienes preguntas sobre estos Términos de Servicio, puedes
              contactarnos respondiendo al correo electrónico desde el cual
              recibiste tu producto.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}